var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
import { forEach } from 'lodash';
var itemImagePlaceholder = 'http://via.placeholder.com/300x225'; // temp
var SectionModel = /** @class */ (function () {
    function SectionModel(data) {
        this.name = data.name;
        this.items = data.items;
        this.isSecret = data.is_secret;
        this.__mc = 'SectionModel';
    }
    SectionModel.prototype.firstItem = function () {
        return this.items[0];
    };
    return SectionModel;
}());
var CategorySubModel = /** @class */ (function (_super) {
    __extends(CategorySubModel, _super);
    function CategorySubModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.sections = hydrated.sections;
        _this.__mc = 'CategorySubModel';
        return _this;
    }
    CategorySubModel.createSection = function (section) {
        return new SectionModel(section);
    };
    CategorySubModel.prototype.firstItemInSection = function () {
        if (this.sections.length < 1) {
            return;
        }
        return this.sections[0].firstItem();
    };
    // TODO may remove if this granularity isn't needed
    CategorySubModel.prototype.hasSecretSection = function () {
        var sections = this.sections;
        var secretFlag = false;
        forEach(sections, function (section) {
            if (section.isSecret) {
                secretFlag = true;
                return false; // early escape
            }
        });
        return secretFlag;
    };
    CategorySubModel.prototype.itemsInSections = function () {
        var items = [];
        this.sections.forEach(function (section) {
            section.items.forEach(function (item) {
                items.push(item);
            });
        });
        return items;
    };
    CategorySubModel.prototype.hydrate = function (data) {
        var subCategory = {};
        subCategory['sections'] = data.sections || null;
        var sections = subCategory['sections'];
        if (sections) {
            var createSection = CategorySubModel.createSection;
            subCategory['sections'] = sections.map(createSection);
        }
        return subCategory;
    };
    CategorySubModel.prototype.hydrateFromStore = function (data) {
        var subCategory = {};
        subCategory = data;
        return subCategory;
    };
    return CategorySubModel;
}(BaseModel));
export default CategorySubModel;
export { SectionModel };



//////////////////
// WEBPACK FOOTER
// ./src/models/CategorySubModel.ts
// module id = HE2C
// module chunks = 18